import { Trans } from "@lingui/react/macro";
import { observer } from "mobx-react-lite";
import React from "react";

import { cn } from "@/utils/shadcn-ui";

import { DataModel } from "../../../models/data-model";
import { Dialog as BaseDialog, DialogContent } from "../base/dialog";
import { Button } from "../button";
import {
  DIALOG_CARD_CLASS,
  DialogBody,
  DialogFooter,
  DialogHeader,
} from "../dialog";

export const ChoosingModal = observer(function ChoosingModal({
  model,
  title,
  onConfirm,
  onClose,
  table,
  readOnly,
  loading,
  fillHeight,
  ownSections,
}: {
  model?: DataModel;
  title: React.ReactNode;
  onConfirm: (params: { selected: any[] }) => void;
  onClose: () => void;
  table: React.ReactNode;
  readOnly?: boolean;
  loading?: boolean;
  /**
   * The table scrolls its own rows (pass `fillHeight` to DataTable too)
   * instead of the whole table region scrolling inside the modal.
   */
  fillHeight?: boolean;
  /**
   * `table` renders its own DialogBody and DialogFooter — a create form shown
   * in place of the list — so the modal adds neither around it.
   */
  ownSections?: boolean;
}) {
  const closeModal = () => {
    onClose();
  };

  return (
    <BaseDialog
      open
      onOpenChange={(open) => {
        if (!open) {
          closeModal();
        }
      }}
    >
      <DialogContent
        className={cn(
          DIALOG_CARD_CLASS,
          "max-h-[80vh] sm:max-w-[calc(100vw-4rem)]",
        )}
        showCloseButton={false}
      >
        <DialogHeader>{title}</DialogHeader>

        {ownSections && !loading ? (
          table
        ) : (
          <DialogBody
            className={
              fillHeight ? "flex flex-col overflow-y-hidden" : undefined
            }
          >
            {loading ? <Trans>Loading...</Trans> : table}
          </DialogBody>
        )}

        {!readOnly && model && !loading && (
          <DialogFooter>
            <Button onClick={closeModal}>
              <Trans>Cancel</Trans>
            </Button>
            <Button
              variant="primary"
              disabled={
                model.selectionMode === "single" && model.selected.length === 0
              }
              onClick={() => {
                onConfirm({ selected: [...model.selected] });
                closeModal();
              }}
            >
              <Trans>Confirm</Trans>
            </Button>
          </DialogFooter>
        )}
      </DialogContent>
    </BaseDialog>
  );
});
